export default {
  container: {
    width: '100%',
    height: '100%'
  },
  imageStyle: {
    position: 'relative !important',
    objectFit: 'cover',
    width: '100%',
    height: '100%',
    aspectRatio: '1/1'
  },
  heading: {
    pt: '16px'
  }
};